import colors from '../../colors.styles';

export const buttonStyle = {
  borderColor: '#dbe2e6',
  borderRadius: '8px',
  color: '#041f41',
  fontSize: '14px',
  fontWeight: 700,
  minHeight: '36px',
  px: 2,
  textTransform: 'none',
  transition: 'transform 120ms cubic-bezier(0.2, 0, 0, 1)',
  '&:hover': {
    backgroundColor: colors.base.barely_blue,
    borderColor: '#a7b1c0',
  },
  '&:active': { transform: 'scale(0.96)' },
};

const adminFormStyles = {
  page: {
    backgroundColor: '#f6f6f6',
    minHeight: '100vh',
    mx: { xs: -3, sm: -6 },
    my: -3,
    px: { xs: 3, sm: 6 },
    py: 4,
    WebkitFontSmoothing: 'antialiased',
  },
  content: {
    marginX: 'auto',
    maxWidth: 1000,
  },
  section: {
    borderColor: '#dbe2e6',
    borderRadius: '12px',
    boxShadow: 'none',
  },
  field: {
    '& .MuiOutlinedInput-root': {
      backgroundColor: colors.base.light,
      borderRadius: '8px',
      fontSize: '14px',
      '& fieldset': { borderColor: '#dbe2e6' },
      '&:hover fieldset': { borderColor: '#a7b1c0' },
      '&.Mui-focused fieldset': { borderColor: colors.base.walmart_blue },
    },
    '& .MuiOutlinedInput-input': {
      padding: '12px 16px',
    },
  },
  secondaryButton: buttonStyle,
  primaryButton: {
    ...buttonStyle,
    backgroundColor: colors.base.walmart_blue,
    borderColor: colors.base.walmart_blue,
    color: colors.base.light,
    '&:hover': {
      backgroundColor: colors.base.dark_blue,
      borderColor: colors.base.dark_blue,
    },
  },
  backButton: {
    color: '#656d80',
    fontSize: '13px',
    minHeight: 28,
    minWidth: 0,
    mb: 0.5,
    p: 0,
    textTransform: 'none',
    '&:hover': { backgroundColor: 'transparent', color: '#041f41' },
  },
  pageTitle: {
    color: '#041f41',
    fontSize: '24px',
    fontWeight: 800,
    lineHeight: 1.5,
    textWrap: 'balance',
  },
  sectionTitle: {
    color: '#041f41',
    fontSize: '16px',
    fontWeight: 800,
  },
  sectionDescription: {
    color: '#656d80',
    fontSize: '14px',
    mt: 0.5,
  },
  fieldLabel: {
    color: '#041f41',
    fontSize: '14px',
    fontWeight: 700,
  },
  helperText: {
    color: '#656d80',
    fontSize: '12px',
  },
  optionalLabel: {
    color: '#656d80',
    fontSize: '14px',
    fontWeight: 400,
  },
};

export default adminFormStyles;
